import { render, staticRenderFns } from "./html.vue?vue&type=template&id=38bffc0a&"
import script from "./html.vue?vue&type=script&lang=js&"
export * from "./html.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bffc0a')) {
      api.createRecord('38bffc0a', component.options)
    } else {
      api.reload('38bffc0a', component.options)
    }
    module.hot.accept("./html.vue?vue&type=template&id=38bffc0a&", function () {
      api.rerender('38bffc0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/html.vue"
export default component.exports